import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import { of } from 'rxjs';
import { VenueLaneAuthService } from 'src/app/services/venues/venue-lane-auth.service';
import { DC_ROUTING, toVenueRoute } from 'src/app/shared/routing.tokens';

export const notVenueModeGuard: CanActivateFn = () => {
    const navController: NavController = inject(NavController);
    const venueLaneAuthService: VenueLaneAuthService = inject(VenueLaneAuthService);

    if (venueLaneAuthService.hasVenueAccessToken()) {
        navController.navigateRoot(toVenueRoute(DC_ROUTING.DASHBOARD_VENUE));
        return of(false);
    }

    return of(true);
};
